export default "__VITE_ASSET__BCJORadY__"